import styled from 'styled-components';

export const StyledButton = styled.button({
    width: '180px',
    height: '60px',
    borderRadius: '20px',
    border: 'solid 2px #f40040aa',
    cursor: 'pointer',
    transition: 'all 0.12s ease-in-out',
    backgroundColor: '#ffffff11',
    color: '#000',
    fontSize: '20px',
    fontWeight: '600',
    fontFamily: 'Mona Sans',

    '&:hover': {
        boxShadow: '0px 0px 10px #f4004088',
        transition: 'all 0.12s ease-in-out',
    },

    '&:active': {
        transform: 'scale(0.99) translate(0px, 2px)',
        boxShadow: '0px 0px 12px #f40040dd',
        backgroundColor: '#00000011',
    },
})

export const StyledButton2 = styled.button({
    width: '180px',
    height: '60px',
    borderRadius: '20px',
    border: 'solid 1px #9b8aff',
    cursor: 'pointer',
    transition: 'all 0.12s ease-in-out',
    backgroundColor: '#ffffff11',
    color: '#fff',
    fontSize: '18px',
    fontWeight: '600',
    fontFamily: 'Mona Sans',

    '&:hover': {
        boxShadow: '0px 0px 10px #9b8aff',
        transition: 'all 0.12s ease-in-out',
    },

    '&:active': {
        transform: 'scale(0.99) translate(0px, 2px)',
        boxShadow: '0px 0px 12px #CbBaff',
        backgroundColor: '#00000011',
    },
})

export const StyledRowTextImg2 = styled.div({
    display: 'flex',
    background: 'linear-gradient(135deg, rgba(193,142,255,0.25) 0%, rgba(46,9,121,0) 51%, rgba(151,146,254,0.25) 100%)',
    color: '#FFF',
    borderRadius: '20px',
    padding: '64px',
    boxShadow: '0px 0px 10px #0d1117',
    marginBottom: '32px',

    '@media (max-width: 900px)': {
        padding: '32px',
    },

    '@media (max-width: 600px)': {
        padding: '18px',
    },

    '& div': {
        '&.txt-container': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'start',

            '@media (max-width: 900px)': {
                alignItems: 'center',
                textAlign: 'center',
            },
        },

        '&.img-container': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',

            '@media (max-width: 900px)': {
                paddingTop: '16px',
                paddingBottom: '32px',
                alignItems: 'center',
                textAlign: 'center',
            },
        }
    },

    '& p': {
        width: '100%',

        '&.subtitle': {
            fontSize: '28px',
            lineHeight: '38px',
            fontWeight: '600',
            margin: '0px',
            transition: 'all 0.3s ease-in-out',
            color: '#FFF',

            '@media (max-width: 1200px)': {
                fontSize: '24px',
                lineHeight: '30px',
                fontWeight: '600',
            },

            '@media (max-width: 900px)': {
                fontSize: '24px',
                lineHeight: '30px',
                fontWeight: '600',
            },

            '@media (max-width: 600px)': {
                fontSize: '22px',
                lineHeight: '28px',
                fontWeight: '500',
            },
        },
        '& span': {
            color: '#939aff',
        }
    },

    '&:hover': {
        background: 'linear-gradient(150deg, rgba(193,142,255,0.30) 0%, rgba(46,9,121,0.10) 51%, rgba(151,146,254,0.30) 100%)',
        transition: 'all 1s ease-in-out',
    }
})

export const StyledSubtitle = styled.p({
    fontSize: '32px',
    textShadow: '1px 1px 2px #0d1117',
    transition: 'all 0.3s ease-in-out',
    // marginBottom: '128px',
    marginTop: '0px',
    maxWidth: '910px',
    lineHeight: '44px',
    color: '#FFF',
    paddingLeft: '12px',

    '@media (max-width: 900px)': {
        maxWidth: '600px',
    },

    '@media (max-width: 600px)': {
        fontSize: '24px',
        marginBottom: '64px',
        lineHeight: '32px',
        transition: 'all 0.3s ease-in-out',
    },

    '@media (max-width: 420px)': {
        fontSize: '20px',
        marginBottom: '64px',
        lineHeight: '28px',
        transition: 'all 0.3s ease-in-out',
    },

    '& span': {
        color: '#9b8aff',
    },
})